import config from "@configs/app";

/**
 * App Logger class
 *
 * @description A wrapper of window.console for all logging stuff.
 * In production these will be replaced with empty methods.
 * This class is extended to provide additional method for custom logging e.g. log to server
 */
class AppLogger {
  /**
   * @constructor AppLogger
   */
  constructor() {
    this.initLogger();
  }

  /**
   * @description disabled window console feaure for production environemnt, except logToServer method
   */
  initLogger() {
    if (config.productionMode) {
      this.log = this.debug = this.info = this.warn = this.error = () => {};
      this.logToServer = (err) => {
        console.error(err);
      };
    } else {
      this.log = console.log.bind(console);
      this.debug = console.debug.bind(console);
      this.info = console.info.bind(console);
      this.warn = console.warn.bind(console);
      this.error = console.error.bind(console);
      this.logToServer = this.error;
    }
  }
}

const logger = new AppLogger();

export { logger };
